import React from 'react';

interface ClubLogoProps {
  logoUrl?: string | null;
  altText?: string;
  className?: string;
  width?: string;
  variant?: 'default' | 'circular' | 'bordered';
}

const ClubLogo: React.FC<ClubLogoProps> = ({ 
  logoUrl, 
  altText = 'Hockey Club', 
  className = '', 
  width = '48px',
  variant = 'circular'
}) => {
  const baseClasses = 'object-contain';
  
  // Use favicon.svg as fallback when no logoUrl is provided
  const logoSrc = logoUrl || "/favicon.svg";
  
  // Debug: Log when we're using fallback (development only)
  if (!logoUrl && process.env.NODE_ENV !== 'production') {
    console.log('ClubLogo: Using fallback, logoUrl was:', logoUrl, 'altText:', altText);
  }
  
  if (variant === 'circular') {
    // Circle stays same size as requested, logo is smaller to fit inside circle
    return (
      <div 
        className={`flex items-center justify-center bg-wit-vast rounded-full overflow-hidden ${className}`}
        style={{ 
          width: width, 
          height: width, 
          minWidth: width, 
          minHeight: width 
        }}
      >
        <img 
          src={logoSrc} 
          alt={altText}
          className={`${baseClasses}`}
          style={{ 
            width: `calc(${width} * 0.8)`, 
            height: `calc(${width} * 0.8)`,
            maxWidth: `calc(${width} * 0.8)`,
            maxHeight: `calc(${width} * 0.8)`
          }}
        />
      </div>
    );
  }
  
  if (variant === 'bordered') {
    return (
      <img 
        src={logoSrc} 
        alt={altText}
        style={{ width }}
        className={`${baseClasses} border-2 border-white border-opacity-30 rounded ${className}`}
      />
    );
  }
  
  // Default variant
  return (
    <img 
      src={logoSrc} 
      alt={altText}
      style={{ width }}
      className={`${baseClasses} ${className}`}
    />
  );
};

export default ClubLogo;